import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function BlogPage() {
  return (
    <div className="page-container">
      <SEO 
        title="Blog - Virgil AI Writer | AI Writing Tips & Screenwriting Insights"
        description="Virgil's writing and product blog is under construction."
        keywords="AI writing blog, screenwriting tips, AI writer tutorials, creative writing AI"
        noindex
      />
      <section className="content-section">
        <h1 className="page-title">Virgil Blog</h1>
        <div className="page-content">
          <p className="page-lead">
            Insights on storytelling, AI, and the craft of writing.
          </p>
          
          <div className="page-note-card page-note-card-lg">
            <h2 className="page-note-title">Coming Soon</h2>
            <p className="page-note-copy">
              We're working on writing about screenwriting, AI-assisted creativity, and where storytelling is going. Check back soon.
            </p>
            <button onClick={() => window.location.href = '/'} className="cta-button secondary">
              Back to Home
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogPage;

